window.addEventListener('DOMContentLoaded', function() {
  console.log('done');
    $('li.menu-item-has-children>a').click(function(e) {
        e.preventDefault();
    });
  // $('body').on('click','li.menu-item-has-children',function (e) {
  //   $(this).toggleClass('active');
  //   e.preventDefault();
  // })
})